const t = (o) => o.modal;
export {
  t as selectModalOptions
};
//# sourceMappingURL=selectors.js.map
